import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import { isMobile } from '@/utils/ua';

import {
  getCacheUserInfo
} from '@/utils/auth';

const bizManager = [{
  path: 'publish-proj',
  name: 'PublishProject',
  meta: {
    title: '已发布项目',
    notRequireAuth: false
  },
  component: () => import( /* webpackChunkName: "PublishProject" */
    '../components/personal-center/PublishProject.vue'),
},
{
  path: 'source-match',
  name: 'SourceMatch',
  meta: {
    title: ' 资源匹配',
    notRequireAuth: false
  },
  component: () => import( /* webpackChunkName: "SourceMatch" */ '../components/personal-center/SourceMatch.vue'),
},
{
  path: 'engage-specialist',
  name: 'EngageSpecialist',
  meta: {
    title: '聘专家',
    notRequireAuth: false
  },
  component: () => import( /* webpackChunkName: "EngageSpecialist" */
    '../components/personal-center/EngageSpecialist.vue'),
},
{
  path: 'policy-advisory',
  name: 'PolicyAdvisory',
  meta: {
    title: '政策咨询',
    notRequireAuth: false
  },
  component: () => import( /* webpackChunkName: "PolicyAdvisory" */
    '../components/personal-center/PolicyAdvisory.vue'),
},
{
  path: 'create-standard',
  name: 'CreateStandard',
  meta: {
    title: '创标准',
    notRequireAuth: false
  },
  component: () => import( /* webpackChunkName: "CreateStandard" */
    '../components/personal-center/CreateStandard.vue'),
},
{
  path: 'my-video',
  name: 'MyVideo',
  meta: {
    title: '我的视频',
    notRequireAuth: false
  },
  component: () => import( /* webpackChunkName: "MyVideo" */ '../components/personal-center/MyVideo.vue'),
},
{
  path: 'mutual-evaluation',
  name: 'MutualEvaluation',
  meta: {
    title: '评价',
    notRequireAuth: false
  },
  component: () => import( /* webpackChunkName: "MutualEvaluation" */
    '../components/personal-center/MutualEvaluation.vue'),
}
];

Vue.use(VueRouter);
//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
const routes = [{
  path: '/',
  name: 'Home',
  component: Home,
  meta: {
    notRequireAuth: true
  },
},
{
  path: '/about',
  name: 'About',
  meta: {
    notRequireAuth: true
  },
  component: () => import( /* webpackChunkName: "about" */ '../views/About.vue'),
},
{
  path: '/contact',
  name: 'Contact',
  meta: {
    notRequireAuth: true
  },
  component: () => import( /* webpackChunkName: "contact" */ '../views/Contact.vue'),
},
{
  path: '/help',
  name: 'Help',
  meta: {
    notRequireAuth: true
  },
  component: () => import( /* webpackChunkName: "help" */ '../views/Help.vue'),
},
{
  path: '/m-home',
  name: 'mHome',
  meta: {
    title: '个人中心',
    notRequireAuth: true
  },
  component: () => import( /* webpackChunkName: "MobileHome" */ '../views/MobileHome.vue'),
},
{
  path: '/login',
  name: 'Login',
  meta: {
    notRequireAuth: true
  },
  component: () => import( /* webpackChunkName: "login" */ '../views/Login.vue'),
},
{
  path: '/register',
  name: 'register',
  meta: {
    notRequireAuth: true
  },
  component: () => import( /* webpackChunkName: "register" */ '../views/Register.vue'),
},
{
  path: '/oneroad',
  name: 'oneroad',
  meta: {
    notRequireAuth: true
  },
  component: () => import( /* webpackChunkName: "register" */ '../views/OneRoadView.vue'),
},
{
  path: '/bindCount',
  name: 'bindCount',
  meta: {
    notRequireAuth: true
  },
  component: () => import( /* webpackChunkName: "bindCount" */ '../views/BindCount.vue'),
},
{
  path: '/findpass',
  name: 'findpass',
  meta: {
    notRequireAuth: true
  },
  component: () => import( /* webpackChunkName: "findpass" */ '../views/Findpass.vue'),
},
{
  path: '/vip',
  name: 'vip',
  meta: {
    notRequireAuth: true
  },
  component: () => import( /* webpackChunkName: "vip" */ '../views/Vip.vue'),
},
{
  path: '/personal-center',
  name: 'personalcenter',
  component: () => import( /* webpackChunkName: "personalcenter" */ '../views/PersonalCenter.vue'),
  children: [{
    path: 'profile',
    name: 'Profile',
    meta: {
      title: '',
      notRequireAuth: false
    },
    component: () => import( /* webpackChunkName: "profile" */ '../components/personal-center/Profile.vue'),
  },
  {
    path: 'm-mine',
    name: 'mMine',
    meta: {
      title: '个人中心',
      notRequireAuth: false
    },
    component: () => import( /* webpackChunkName: "MobileNav" */ '../components/personal-center/MobileNav.vue'),
  },
  {
    path: 'org',
    name: 'Organization',
    meta: {
      title: '机构管理',
      notRequireAuth: false
    },
    component: () => import( /* webpackChunkName: "organization" */
      '../components/personal-center/Organization.vue'),
  },
  {
    path: 'specialist',
    name: 'Specialist',
    meta: {
      title: '专家管理',
      notRequireAuth: false
    },
    component: () => import( /* webpackChunkName: "specialist" */
      '../components/personal-center/Specialist.vue'),
  },
  {
    path: 'specialist-create',
    name: 'SpecialistCreate',
    meta: {
      title: '专家绑定',
      notRequireAuth: false
    },
    component: () => import( /* webpackChunkName: "SpecialistCreate" */
      '../components/personal-center/SpecialistCreate.vue'),
  },
  {
    path: 'org-create',
    name: 'OrganizationCreate',
    meta: {
      title: '机构管理',
      notRequireAuth: false
    },
    component: () => import( /* webpackChunkName: "OrganizationCreate" */
      '../components/personal-center/OrganizationCreate.vue'),
  },
  {
    path: 'passw-change',
    name: 'PasswordChange',
    meta: {
      title: '密码修改',
      notRequireAuth: false
    },
    component: () => import( /* webpackChunkName: "PasswordChange" */
      '../components/personal-center/PasswordChange.vue'),
  },
  {
    path: 'message-c',
    name: 'MessageCenter',
    meta: {
      title: '全部消息',
      notRequireAuth: false
    },
    component: () => import( /* webpackChunkName: "MessageCenter" */
      '../components/personal-center/MessageCenter.vue'),
  },
  {
    path: 'product-m',
    name: 'productmanager',
    meta: {
      title: '编辑产品',
      notRequireAuth: false
    },
    component: () => import( /* webpackChunkName: "productmanager" */
      '../components/personal-center/ProductManager.vue'),
  },
  {
    path: 'scene-m',
    name: 'SceneManager',
    meta: {
      title: '智慧场景',
      notRequireAuth: false
    },
    component: () => import( /* webpackChunkName: "SceneManager" */
      '../components/personal-center/SceneManager.vue'),
  },
  {
    path: 'service-m',
    name: 'ServiceManager',
    meta: {
      title: '编辑服务',
      notRequireAuth: false
    },
    component: () => import( /* webpackChunkName: "ServiceManager" */
      '../components/personal-center/ServiceManager.vue'),
  },
  {
    path: 'case-m',
    name: 'SuccessCaseManager',
    meta: {
      title: '编辑案例',
      notRequireAuth: false
    },
    component: () => import( /* webpackChunkName: "SuccessCaseManager" */
      '../components/personal-center/SuccessCaseManager.vue'),
  },
  ...bizManager
  ]
},
{
  path: '/detail',
  name: 'Detail',
  component: () => import( /* webpackChunkName: "Detail" */ '../views/Detail.vue'),
  children: [{
    path: 'product',
    name: 'ProductDetail',
    meta: {
      notRequireAuth: false
    },
    component: () => import( /* webpackChunkName: "ProductDetail" */ '../components/detail/ProductDetail.vue'),
  },
  {
    path: 'service',
    name: 'ServiceDetail',
    meta: {
      notRequireAuth: false
    },
    component: () => import( /* webpackChunkName: "ServiceDetail" */ '../components/detail/ServiceDetail.vue'),
  },
  {
    path: 'case',
    name: 'SuccessCaseDetail',
    meta: {
      notRequireAuth: false
    },
    component: () => import( /* webpackChunkName: "SuccessCaseDetail" */
      '../components/detail/SuccessCaseDetail.vue'),
  },
  {
    path: 'video',
    name: 'VideoDetail',
    meta: {
      notRequireAuth: false
    },
    component: () => import( /* webpackChunkName: "VideoDetail" */ '../components/detail/VideoDetail.vue'),
  },
  {
    path: 'org-detail',
    name: 'OrganizationDetail',
    meta: {
      notRequireAuth: false
    },
    component: () => import( /* webpackChunkName: "OrganizationDetail" */
      '../views/details/OrganizationDetail.vue'),
  },
  {
    path: 'standard-detail',
    name: 'StandardDetail',
    meta: {
      notRequireAuth: false
    },
    component: () => import( /* webpackChunkName: "StandardDetail" */ '../views/details/StandardDetail.vue'),
  },
  {
    path: 'gsstandard-detail',
    name: 'GSStandardDetail',
    meta: {
      notRequireAuth: false
    },
    component: () => import( /* webpackChunkName: "StandardDetail" */ '../views/details/GsStandardDetail.vue'),
  },
  ]
},
{
  path: '/policy',
  name: 'Policy',
  meta: {
    notRequireAuth: true
  },
  component: () => import( /* webpackChunkName: "Policy" */ '../views/Policy.vue'),
},
{
  path: '/policy-detail',
  name: 'PolicyDetail',
  meta: {
    notRequireAuth: false
  },
  component: () => import( /* webpackChunkName: "PolicyDetail" */ '../views/PolicyDetail.vue'),
},
{
  path: '/policy-qa',
  name: 'PolicyQA',
  meta: {
    notRequireAuth: false
  },
  component: () => import( /* webpackChunkName: "PolicyQA" */ '../views/PolicyQA.vue'),
},
{
  path: '/standardcreate',
  name: 'StandardCreate',
  meta: {
    notRequireAuth: false
  },
  component: () => import( /* webpackChunkName: "StandardCreate" */ '../views/standard/StandardCreate.vue'),
},
{
  path: '/standardSigup',
  name: 'StandardSigup',
  meta: {
    notRequireAuth: false
  },
  component: () => import( /* webpackChunkName: "StandardCreate" */ '../views/standard/StandardSigUP.vue'),
},
{
  path: '/special-find',
  name: 'SpecialFind',
  meta: {
    notRequireAuth: false
  },
  component: () => import( /* webpackChunkName: "SpecialFind" */ '../views/SpecialFind.vue'),
},
{
  path: '/project',
  name: 'Project',
  meta: {
    notRequireAuth: true
  },
  component: () => import( /* webpackChunkName: "Project" */ '../views/Project.vue'),
},
{
  path: '/project-publish',
  name: 'ProjectPublish',
  meta: {
    notRequireAuth: false
  },
  component: () => import( /* webpackChunkName: "ProjectPublish" */ '../views/ProjectPublish.vue'),
},
{
  path: '/project-find',
  name: 'ProjectFind',
  meta: {
    notRequireAuth: true
  },
  component: () => import( /* webpackChunkName: "ProjectFind" */ '../views/ProjectFind.vue'),
},
{
  path: '/financial',
  name: 'Financial',
  meta: {
    notRequireAuth: true
  },
  component: () => import( /* webpackChunkName: "Financial" */ '../views/Financial.vue'),
},
{
  path: '/specialist',
  name: 'VSpecialist',
  meta: {
    notRequireAuth: true
  },
  component: () => import( /* webpackChunkName: "VSpecialist" */ '../views/VSpecialist.vue'),
},
{
  path: '/specialist-detail',
  name: 'VSpecialistDetail',
  meta: {
    notRequireAuth: false
  },
  component: () => import( /* webpackChunkName: "VSpecialistDetail" */ '../views/VSpecialistDetail.vue'),
},
{
  path: '/organization',
  name: 'VOrganization',
  meta: {
    notRequireAuth: true
  },
  component: () => import( /* webpackChunkName: "VOrganization" */ '../views/VOrganization.vue'),
},
{
  path: '/difangchanye',
  name: 'difangchanye',
  meta: {
    notRequireAuth: true
  },
  component: () => import( /* webpackChunkName: "VOrganization" */ '../views/DifangView.vue'),
},
{
  path: '/product',
  name: 'Product',
  meta: {
    notRequireAuth: true
  },
  component: () => import( /* webpackChunkName: "Product" */ '../views/Product.vue'),
},
{
  path: '/service',
  name: 'Service',
  meta: {
    notRequireAuth: true
  },
  component: () => import( /* webpackChunkName: "Service" */ '../views/Service.vue'),
},
{
  path: '/standard',
  name: 'Standard',
  meta: {
    notRequireAuth: true
  },
  component: () => import( /* webpackChunkName: "VStandard" */ '../views/VStandard.vue'),
},
{
  path: '/scene',
  name: 'Scene',
  meta: {
    notRequireAuth: false
  },
  component: () => import( /* webpackChunkName: "SceneView" */ '../views/SceneView.vue'),
},
];

const router = new VueRouter({
  routes,
});

//全局守卫
router.beforeEach((to, from, next) => {
  try {
    const userInfo = getCacheUserInfo();
    // console.log(userInfo, '>userInfo', to.path)
    // let userId = userInfo && userInfo.uid;
    //这里是对登录后的值进行判断，也可对token的值进行判断
    // console.log("userInfo---",userInfo)
    if (isMobile() && to.name === 'Home') {
      next({
        path: '/m-home'
      })
      return;
    } else if (!isMobile() && to.name === 'mHome') {
      next({
        path: '/'
      })
      return;
    }
    if (!userInfo.uid) {
      if (!to.meta.notRequireAuth || to.name == null) {
        next({
          path: '/login'
        })
        return false;
      } else {
        next();
      }
    } else {
      next();
    }
  } catch (error) {
    console.log(error)
  }
});
export default router;
